export var CustomPDFReportsDropdownOption;
(function (CustomPDFReportsDropdownOption) {
    CustomPDFReportsDropdownOption["DELETE"] = "delete";
    CustomPDFReportsDropdownOption["DUPLICATE"] = "duplicate";
    CustomPDFReportsDropdownOption["GENERATE_REPORT"] = "generate_report";
    CustomPDFReportsDropdownOption["SHARE"] = "share";
    CustomPDFReportsDropdownOption["PREVIEW"] = "preview";
    CustomPDFReportsDropdownOption["MOVE"] = "move";
    CustomPDFReportsDropdownOption["RENAME"] = "rename";
})(CustomPDFReportsDropdownOption || (CustomPDFReportsDropdownOption = {}));
